import Counter from "./Counter";
import Card from "../component/Card";

export const WhyChooseUs = () => {
  return (
    <div>
      <div className=" flex justify-center items-center mt-[10%] md:mt-[5%]">
        <div className="w-[280px] h-[44px] relative p-[2px] rounded-md animated-border flex justify-center items-center">
          <h2
            className="
        w-full h-full bg-white rounded-md text-[16px]
        font-semibold text-[#4D4C4C] font-clash tracking-wide
        flex items-center justify-center gap-3 
      "
          >
            <span className="w-3 h-3 rounded-full bg-primary"></span>

            <span>Why Choose Us</span>
          </h2>
        </div>
      </div>
      <section className="hidden md:block px-20 py-5 md:py-20 ">
        <div className=" flex flex-row gap-10">
          <div className=" w-[566px] h-[365px]">
            <h1 className=" text-[64px] font-clash font-normal  leading-tight mt-[5%] md:mt-[15%]">
              We deliver
              <br />
              <span className="block font-medium text-[80px]  bg-gradient-to-r from-[#FE4A33] to-[#FEAEA4] bg-clip-text text-transparent leading-none">
                Measurable
              </span>
              <span className="block font-medium text-[80px]  bg-gradient-to-r from-[#FE4A33] to-[#FEAEA4] bg-clip-text text-transparent leading-none">
                outcomes
              </span>
            </h1>
          </div>
          <div
            className=" rounded-2xl p-6 bg-white/60 backdrop-blur-md relative w-[360px] h-[365px]
    border border-[#EEEEEE] shadow-[0_8px_30px_rgba(0,0,0,0.04)]
    flex flex-col justify-between group transition-all duration-300"
          >
            <div className="flex relative justify-start w-[150px] h-[150px]">
              <img
                src="/assets/Mask group 5.png"
                alt="icon"
                className="w-full h-auto  absolute -top-10 -left-5"
              />
            </div>
            <div className="flex items-end gap-4 mb-10">
              <h2 className="font-clash font-medium text-[60px] bg-gradient-to-r from-[#FE4A33] to-[#FEAEA4] text-6xl bg-clip-text text-transparent  mt-2">
                <Counter target={12} suffix="+" />
              </h2>
              <span className="font-clash font-medium text-[24px] leading-tight mb-4">
                Industry Reach
              </span>
            </div>
            <p className="font-aileron font-normal text-[14px] text-[#000000B3] mb-5 ">
              This industry project was developed using React to deliver a
              dynamic and responsive web application.
            </p>
          </div>
          <div
            className=" rounded-2xl p-6 bg-white/60 backdrop-blur-md relative w-[360px] h-[365px]
    border border-[#EEEEEE] shadow-[0_8px_30px_rgba(0,0,0,0.04)]
    flex flex-col justify-between group transition-all duration-300"
          >
            <div className="flex relative  w-[150px] h-[150px]">
              <img
                src="/assets/star.png"
                alt="icon"
                className="w-full h-auto  absolute -top-20 -right-48"
              />
            </div>
            <div className="flex items-end gap-4 mb-10">
              <h2 className="font-clash font-medium text-[60px] bg-gradient-to-r from-[#FE4A33] to-[#FEAEA4] text-6xl bg-clip-text text-transparent ">
                <Counter target={200} suffix="+" />
              </h2>
              <span className="font-clash font-medium text-[24px]  leading-tight mb-4">
                Project
              </span>
            </div>
            <p className="font-aileron font-normal text-[14px] text-[#000000B3] mb-5 ">
              This project focused on creating a modern and intuitive user
              experience. Every interface was designed to be responsive
            </p>
          </div>
        </div>

        <div className=" flex flex-row justify-between gap-10 mt-10">
          <div
            className=" rounded-2xl p-6 bg-white/60 backdrop-blur-md relative
    border border-[#EEEEEE] shadow-[0_8px_30px_rgba(0,0,0,0.04)]
    flex flex-col justify-between group transition-all duration-300  w-[428px] h-[360px]"
          >
            <div className="flex relative justify-end w-[150px] h-[150px]">
              <img
                src="/assets/Mask group 6.png"
                alt="icon"
                className="w-full h-auto  absolute -right-60 -top-10"
              />
            </div>
            <div className="flex items-end gap-4 mb-10">
              <h2 className="font-clash font-medium text-[60px] bg-gradient-to-r from-[#FE4A33] to-[#FEAEA4] text-6xl bg-clip-text text-transparent ">
                <Counter target={3} suffix="%" />
              </h2>
              <span className="font-clash font-medium text-[24px]  leading-tight mb-4">
                Country
              </span>
            </div>
            <p className="font-aileron font-normal text-[14px] text-[#000000B3] mb-5 ">
              Our clients consistently provide excellent ratings, highlighting
              our commitment to quality, timely delivery, and exceptional
              service.
            </p>
          </div>

          <div
            className=" rounded-2xl p-6 bg-white/60 backdrop-blur-md relative
    border border-[#EEEEEE] shadow-[0_8px_30px_rgba(0,0,0,0.04)]
    flex flex-col justify-between group transition-all duration-300  w-[428px] h-[360px]"
          >
            <div className="flex relative justify-end  w-[150px] h-[150px]">
              <img
                src="/assets/slinder.png"
                alt="icon"
                className="w-full h-auto  absolute   -right-60 -top-10"
              />
            </div>
            <div className="flex items-end gap-4 mb-10">
              <h2 className="font-clash font-medium text-[60px] bg-gradient-to-r from-[#FE4A33] to-[#FEAEA4] text-6xl bg-clip-text text-transparent ">
                <Counter target={100} suffix="+" />
              </h2>
              <span className="font-clash font-medium text-[24px]  leading-tight mb-4">
                Clients Retained
              </span>
            </div>
            <p className="font-aileron font-normal text-[14px] text-[#000000B3] mb-5 ">
              Our clients choose to stay with us because we focus on building
              strong, lasting relationships. By consistently delivering
              high-quality results and personalized solutions, we earn their
              trust and confidence.
            </p>
          </div>

          <div
            className=" rounded-2xl p-6 bg-white/60 backdrop-blur-md relative
    border border-[#EEEEEE] shadow-[0_8px_30px_rgba(0,0,0,0.04)]
    flex flex-col justify-between group transition-all duration-300  w-[428px] h-[360px]"
          >
            <div className="flex relative justify-end  w-[150px] h-[150px]">
              <img
                src="/assets/dna.png"
                alt="icon"
                className="w-full h-auto  absolute -right-60 -top-10"
              />
            </div>
            <div className="flex items-end gap-4 mb-10">
              <h2 className="font-clash font-medium text-[60px] bg-gradient-to-r from-[#FE4A33] to-[#FEAEA4] text-6xl bg-clip-text text-transparent ">
                <Counter target={4.5} suffix="+" />
              </h2>
              <span className="font-clash font-medium text-[24px]  leading-tight mb-4">
                Rating
              </span>
            </div>
            <p className="font-aileron font-normal text-[14px] text-[#000000B3] mb-5 ">
              Maintaining excellent feedback across all our engagements
              demonstrates our commitment to excellence and the value we
              provide, ensuring our clients feel confident and supported in
              partnering with us.
            </p>
          </div>
        </div>
      </section>

      <section className="block md:hidden max-w-[1300px] mx-auto px-4 sm:px-6 py-10 md:py-20">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 items-start">
          <div className="w-full">
            <h1 className="font-clash font-normal leading-tight mt-6 text-[50px] ">
              We deliver
              <br />
              <span className="block font-medium bg-gradient-to-r from-[#FE4A33] to-[#FEAEA4] bg-clip-text text-transparent leading-none text-[50px] sm:text-[64px] lg:text-[80px]">
                Measurable
              </span>
              <span className="block font-medium bg-gradient-to-r from-[#FE4A33] to-[#FEAEA4] bg-clip-text text-transparent leading-none text-[60px] sm:text-[64px] lg:text-[80px]">
                outcomes
              </span>
            </h1>
          </div>

          <Card
            img="/assets/Mask group 5.png"
            alt="mask"
            imgClass="-top-10 -left-5"
            value={<Counter target={12} suffix="+" />}
            label="Industry Reach"
            text={`This industry project was developed using React to deliver a dynamic and responsive web application.`}
          />

          <Card
            img="/assets/star.png"
            alt="star"
            imgClass=" -top-16 -right-48"
            value={<Counter target={12} suffix="+" />}
            label="Project"
            text={
              "This project focused on creating a modern and intuitive user experience. Every interface was designed to be responsive"
            }
          />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mt-10">
          <Card
            img="/assets/Mask group 6.png"
            alt="mask"
            imgClass="-right-52 -top-10"
            value={<Counter target={98} suffix="%" />}
            label="Country"
            text={`  Our clients consistently provide excellent ratings, highlighting
              our commitment to quality, timely delivery, and exceptional
              service.`}
          />

          <Card
            img="/assets/slinder.png"
            alt="slinder"
            imgClass="-right-52 -top-5"
            value={<Counter target={100} suffix="+" />}
            label="Clients Retained"
            text={` Our clients choose to stay with us because we focus on building
              strong, lasting relationships. By consistently delivering
              high-quality results and personalized solutions, we earn their
              trust and confidence.`}
          />

          <Card
            img="/assets/dna.png"
            
            alt="dna"
            imgClass="-right-48 -top-10"
            value={<Counter target={4.5} suffix="+" />}
            label="Rating"
            text={` Maintaining excellent feedback across all our engagements
              demonstrates our commitment to excellence and the value we
              provide, ensuring our clients feel confident and supported in
              partnering with us.`}
          />
        </div>
      </section>
    </div>
  );
};

export default WhyChooseUs;
